import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { CompanyService } from '@app/shared/services/company.service';
import { IFBSamlProviderInformation, IFBSsoIdentityProvider, SsoMetadata } from '@app/models/sso.model';

@Injectable({
  providedIn: 'root'
})
export class SamlResource {
  constructor(
    private companyService: CompanyService,
    private http: HttpClient
  ) {}

  getMetadata() {
    const url = `https://${this.companyService.subdomain}.${environment.AUTH_BASE}/saml/sp/metadata`;
    return this.http.get<IFBSamlProviderInformation>(url).pipe(
      map(response => {
        response.metadata_url = `https://${this.companyService.subdomain}.${environment.AUTH_BASE}/saml/sp/metadata`;
        return response;
      })
    );
  }

  parse(body: SsoMetadata) {
    const url = `${this.url()}/idp/parse_metadata`;
    return this.http.post<IFBSsoIdentityProvider>(url, body);
  }

  private url(): string {
    return `https://${environment.AUTH_BASE}/saml`;
  }
}
